<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/qycx/qycx-title.png" class="zcqd-title" alt="">
        </div>
        <div class="qycx-info">
          <div class="qycx-item" @click="toList(0)"></div>
          <div class="qycx-item" @click="toList(1)"></div>
          <div class="qycx-item" @click="toList(2)"></div>
          <div class="qycx-item" @click="toList(3)"></div>
          <div class="qycx-item" @click="toList(4)"></div>
          <div class="qycx-item" @click="toList(5)"></div>
        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>

<script>
import services from "../../../assets/js/services.js"
import { mapActions } from "vuex";
export default {
  props: ["scaling"],
  mounted() {
  },
  data() {
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then((res) => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/qycxzf?ind=0`,
        });
        window.open(routeUrl.href, "_blank");

      });

    },
    toList(ind) {
      this.goAppsDetailsBeforeLogin().then((res) => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/qycxzf?ind=${ind}`
        })
        window.open(routeUrl.href, "_blank");
      });

    }
  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;

  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 580px;
          margin-top: 30px;
        }
      }
      .qycx-info {
        width: 1391px;
        height: 674px;
        margin: 116px auto 0;
        position: relative;
        display: flex;
        .qycx-item {
          background-size: cover;
          background-position: center;
          cursor: pointer;
          transition: all .3s;
          &:hover {
            transform: translateY(-20px);
          }
          &:nth-child(1) {
            width: 219px;
            height: 443px;
            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-1.png");
            margin-top: 93px;
          }
          &:nth-child(2) {
            width: 197px;
            height: 400px;
            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-2.png");
            margin-top: 18px;
            margin-left: 15px;
          }
          &:nth-child(3) {
            width: 222px;
            height: 467px;
            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-3.png");
            margin-top: 83px;
            margin-left: 33px;
          }
          &:nth-child(4) {
            width: 222px;
            height: 467px;
            margin-top: 12px;
            margin-left: 25px;

            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-4.png");
          }
          &:nth-child(5) {
            width: 220px;
            height: 448px;
            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-5.png");
            margin-top: 97px;
            margin-left: 31px;
          }
          &:nth-child(6) {
            width: 219px;
            height: 440px;
            background-image: url("../../../assets/image/kjqg/index/qycx/qycx-6.png");
            margin-left: 15px;
          }
        }
      }
      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 0px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>